import { Container, Col, Row, Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import { FaBook, FaSchool, FaUserGraduate, FaRocket, FaChalkboardTeacher, FaLaptop } from "react-icons/fa";
import React, { useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { FaUserFriends, FaSearch, FaCheckCircle, FaLaptopHouse, FaSync } from "react-icons/fa";
import { FaWpforms,  FaCreditCard, FaPlayCircle } from "react-icons/fa";
import "./Home.css";
import { api } from "../api/client";

import picture1 from "../shared/image/picture1.jpg";
import picture2 from "../shared/image/picture2.jpg";
import picture3 from "../shared/image/picture3.jpg";

const EMPTY_FORM = {
  parent_name: "",
  student_name: "",
  phone: "",
  email: "",
  city: "",
  locality: "",
  standard: "",
  subject: "",
};

export default function Home() {
  const slideImages = [
    { url: picture1 },
    { url: picture2 },
    { url: picture3 },
  ];

  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const update = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  async function handleSubmit(e) {
    e.preventDefault();
    setFeedback(null);
    if (!form.parent_name || !form.student_name || !form.phone || !form.standard) {
      setFeedback({ type: "danger", msg: "Parent name, student name, phone, and standard are required." });
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/public/demo-request", form);
      setFeedback({ type: "success", msg: "Thanks! We'll call you back shortly to schedule your demo." });
      setForm(EMPTY_FORM);
    } catch (err) {
      setFeedback({ type: "danger", msg: err.message || "Could not submit. Please try again." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    
    
   <>
    <div className="hero-section">
      <Slide  duration={3000}
            transitionDuration={500}
            infinite={true}
            arrows={true}
            indicators={true}
            pauseOnHover={false}>
        {slideImages.map((slide, index) => (
          <div className="each-slide" key={index}>
            <div
              className="slide-bg"
              style={{ backgroundImage: `url(${slide.url})` }}
            >
              <Container>
                <Row className="align-items-center">

                  {/* LEFT TEXT */}
                  <Col md={6} xs={12} className="text-white mb-4 mb-md-0">
                    <h1 className="hero-title">
                      Take great online courses from anywhere in the world
                    </h1>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore.
                    </p>
                    <h5 className="view-course">VIEW COURSES</h5>
                  </Col>

                  {/* RIGHT FORM */}
                  <Col md={6}  xs={12} >
                    <div className="custom-form">

                      <h3>Student Demo Request</h3>
                      <p>Get instant access to 6500 video courses</p>

                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                          <Col xs={12} md={6} className="mb-3 mb-md-0">
                            <Form.Control placeholder="Parent Name" value={form.parent_name} onChange={update("parent_name")} required />
                          </Col>
                          <Col xs={12} md={6}>
                            <Form.Control placeholder="Student Name" value={form.student_name} onChange={update("student_name")} required />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs={12} md={6} className="mb-3 mb-md-0">
                            <Form.Control placeholder="Phone Number" type="tel" value={form.phone} onChange={update("phone")} required />
                          </Col>
                          <Col xs={12} md={6}>
                            <Form.Control placeholder="Email" type="email" value={form.email} onChange={update("email")} />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs={12} md={6} className="mb-3 mb-md-0">
                            <Form.Select value={form.city} onChange={update("city")}>
                              <option value="">City</option>
                              <option value="Chennai">Chennai</option>
                              <option value="Bangalore">Bangalore</option>
                              <option value="Kolkata">Kolkata</option>
                              <option value="Mumbai">Mumbai</option>
                              <option value="Delhi">Delhi</option>
                            </Form.Select>
                          </Col>
                          <Col xs={12} md={6}>
                            <Form.Control placeholder="Locality" type="text" value={form.locality} onChange={update("locality")} />
                          </Col>
                        </Row>
                        <Form.Group className="mb-3">
                          <Form.Control placeholder="Standard (eg:class-10 CBSE)" value={form.standard} onChange={update("standard")} required />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Control placeholder="Subject" value={form.subject} onChange={update("subject")} />
                        </Form.Group>

                        {feedback && (
                          <Alert variant={feedback.type} className="mb-3 py-2">
                            {feedback.msg}
                          </Alert>
                        )}

                        <Button type="submit" className="submit-btn mb-3" disabled={submitting}>
                          {submitting ? <><Spinner size="sm" animation="border" /> Sending…</> : "Request Information"}
                        </Button>
                      </Form>

                    </div>
                  </Col>

                </Row>
              </Container>
            </div>
          </div>
        ))}
      </Slide>
    </div>
    <div className="py-5 custom-course">
  <Container>
    <Row className="text-center">
      <Col>
        <h1 className="fw-bold">
          From ABCs to Entrance Exams — We've Got It All
        </h1>
        <p className="mt-3 text-muted">
          Explore courses designed for every stage of learning — from beginners
          to advanced competitive exams.
        </p>
      </Col>
    </Row>
   <Row>
  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaBook className="course-icon" />
        <h4>KG to 5th</h4>
        <p>Strong foundation for young learners</p>
      </Card.Body>
    </Card>
  </Col>

  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaSchool className="course-icon" />
        <h4>6th to 10th</h4>
        <p>Build concepts & score high</p>
      </Card.Body>
    </Card>
  </Col>

  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaUserGraduate className="course-icon" />
        <h4>11th & 12th</h4>
        <p>Board & career preparation</p>
      </Card.Body>
    </Card>
  </Col>

  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaRocket className="course-icon" />
        <h4>Entrance Exams</h4>
        <p>JEE, NEET & more</p>
      </Card.Body>
    </Card>
  </Col>

  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaChalkboardTeacher className="course-icon" />
        <h4>10000+ Tutors</h4>
        <p>Top verified teachers</p>
      </Card.Body>
    </Card>
  </Col>

  <Col md={4} className="mb-4">
    <Card className="course-card text-center">
      <Card.Body>
        <FaLaptop className="course-icon" />
        <h4>Live Classes</h4>
        <p>1-on-1 personalized learning</p>
      </Card.Body>
    </Card>
  </Col>
</Row>
  </Container>
</div>


<div className="features-section py-5">
  <Container>

    {/* TITLE */}
    <Row className="text-center mb-5">
      <Col>
        <h2 className="fw-bold">Dedicated Tutors</h2>
        <p className="text-muted">
          Meet our dedicated home tutors tailored to your needs, ensuring academic excellence awaits.
        </p>
      </Col>
    </Row>

    {/* FEATURES ROW */}
    <Row className="text-center justify-content-center">

      <Col xs={6} md={2} className="mb-4">
        <div className="feature-item">
          <div className="icon-circle">
            <FaUserFriends />
          </div>
          <p>Dedicated Tutors</p>
          <p>Meet our dedicated home tutors tailored to your needs, ensuring academic excellence awaits.</p>
        </div>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <div className="feature-item">
          <div className="icon-circle">
            <FaSearch />
          </div>
          <p>Easy Selection</p>
          <p>
            No more endless calls or confusion—just tell us your need, and we'll match you with the right tutor.
          </p>
        </div>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <div className="feature-item">
          <div className="icon-circle">
            <FaCheckCircle />
          </div>
          <p>Verified Tutors</p>
          <p>
            A rigorous screening process ensures quality and reliability
          </p>
        </div>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <div className="feature-item">
          <div className="icon-circle">
            <FaLaptopHouse />
          </div>
          <p>Online & Offline</p>
          <p>
            Learning at your convenience. Choose between In-person or online tutoring
          </p>
        </div>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <div className="feature-item">
          <div className="icon-circle">
            <FaSync />
          </div>
          <p>Replacement</p>
          <p>Swift replacement of tutors if needed, without interrupting learning</p>
        </div>
      </Col>

    </Row>

  </Container>
</div>
<div className="process-section py-5">
  <Container fluid className="customback">
    <Row className="text-center mb-5">
      <Col>
        <h2 className="fw-bold">How It Works</h2>
        <p className="text-muted">
          A simple 4-step process to get started with your tutor
        </p>
      </Col>
    </Row>

    <Row className="justify-content-center text-center">

      <Col xs={6} md={2} className="mb-4">
        <Card className="process-card">
          <Card.Body>
            <FaWpforms className="process-icon" />
            <Card.Text>Submit Enquiry</Card.Text>
            <Card.Text>Fill out a quick form, sharing your subject, grade level, and any specific requirements you have.</Card.Text> 
          </Card.Body>
        </Card>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <Card className="process-card">
          <Card.Body>
            <FaChalkboardTeacher className="process-icon" />
            <Card.Text>Attend Demo</Card.Text>
              <Card.Text>Interact with potential tutors to assess their teaching methods and compatibility with your child.</Card.Text> 
          </Card.Body>
        </Card>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <Card className="process-card">
          <Card.Body>
            <FaCreditCard className="process-icon" />
            <Card.Text>Make Payment</Card.Text>
            <Card.Text>Choose a convenient payment plan and secure the tutor's services.</Card.Text>
          </Card.Body>
        </Card>
      </Col>

      <Col xs={6} md={2} className="mb-4">
        <Card className="process-card">
          <Card.Body>
            <FaPlayCircle className="process-icon" />
            <Card.Text>Initiate Tuition</Card.Text>
             <Card.Text>Let's get your child's learning journey started. Schedule their first session today!</Card.Text>
          </Card.Body>
        </Card>
      </Col>

    </Row>
  </Container>
</div>
 
     </>
  );
}